export class AdditionalInsurers {
  number: string;
  birthAgeInYears: number;
  date: string;
  invalid: boolean;
  error: string;
  index: number;
  errorMessage:string
}
